import type { GetPropertyTypesQuery } from '@graphql/__generated__/graphql';
import type { TransactionFormData } from '@modules/_shared/components/create-transaction/hooks/useTransactionStepper';
import type { TransactionPreviewItem } from '@modules/_shared/components/create-transaction/TransactionPreviewCard';
import { formatAddress } from '@modules/_shared/utils/formatting';
import { formatTransactionPreviewRooms } from '@modules/_shared/utils/transactionPreview';
import type { Translate } from '@shared/hooks/locale';

type BuildTransactionPreviewItemArgs = {
  formData: TransactionFormData;
  propertyTypes: GetPropertyTypesQuery['property_types'];
  locale: string;
  t: Translate;
  brokerName?: string | null;
  teamName?: string | null;
};

export const buildTransactionPreviewItem = ({
  formData,
  propertyTypes,
  locale,
  t,
  brokerName,
  teamName,
}: BuildTransactionPreviewItemArgs): TransactionPreviewItem => {
  const { address, property, details, photos } = formData;
  const propertyTitle =
    propertyTypes.find(pt => pt.id === property?.property_type_id)?.label ||
    t('Property');
  const roomsInfo = formatTransactionPreviewRooms(property, locale, t);
  const location =
    address?.postcode && address?.locality
      ? `${address.postcode} ${address.locality}`
      : address
      ? formatAddress(address, ', ', true)
      : '-';

  return {
    propertyTitle,
    roomsInfo,
    location,
    photoUrl: photos?.uploadedImage?.url ?? null,
    listingImage: photos?.listingImage ?? null,
    signatureDate: details?.signature_date ?? null,
    brokerName: brokerName ?? null,
    teamName: teamName ?? null,
  };
};
